var _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEsVyro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_12106_413)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4231 16.3089C17.4231 17.2404 17.4305 18.1705 17.4194 19.1019C17.4156 19.4546 17.5521 19.6834 17.845 19.8032C18.1527 19.9284 18.4468 19.9028 18.6552 19.5972C18.8265 19.3469 18.9753 19.075 19.1193 18.8044C20.4817 16.2403 21.8329 13.6707 23.204 11.112C24.4783 8.7322 27.3545 8.02689 29.4217 9.63269C30.7829 10.6893 31.3921 12.1686 31.2222 14.0099C31.1353 14.9495 30.7233 15.7261 30.304 16.5135C29.0147 18.9283 27.7367 21.3511 26.4512 23.7686C25.5318 25.4968 24.6235 27.2318 23.6768 28.9413C22.7908 30.5431 21.4322 31.3251 19.736 31.2443C17.8847 31.1555 16.3225 29.8364 15.7989 27.781C15.6736 27.2897 15.6363 26.7877 15.6351 26.2843C15.6289 23.7497 15.6338 21.2138 15.6301 18.6793C15.6301 17.9241 15.2542 17.6226 14.5829 17.8205C14.5134 17.8407 14.4451 17.869 14.3757 17.8918C12.0268 18.651 9.64445 17.2834 8.93471 14.7691C8.23117 12.2736 9.6035 9.59365 11.9288 8.91795C14.2739 8.23687 16.6017 9.68249 17.2556 12.2534C17.3673 12.6949 17.4231 13.1539 17.4231 13.6169C17.4231 14.5147 17.4231 15.4111 17.4231 16.3089Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12106_413",
    x1: -0.000308861,
    y1: 19.9995,
    x2: 39.999,
    y2: 19.9995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#107F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AFF7F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsVyro);
export default __webpack_public_path__ + "static/media/esVYRO.563fabba.svg";
export { ForwardRef as ReactComponent };